import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductImageItem } from '../product-info-step.model';

@Component({
  selector: 'app-product-images',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-images.html',
    styleUrl: './product-images.scss',
})
export class ProductImages {
  images     = input.required<ProductImageItem[]>();
  errors     = input.required<string[]>();

  fileSelect = output<File[]>();
  setPrimary = output<number>();
  removeImg  = output<number>();

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files ?? []) as File[];
    this.fileSelect.emit(files);
    input.value = '';
  }
}